import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import UserSetting from 'components/Admin/UserSetting';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <UserSetting />
      </SiteContent>
    </ContentLayout>
  );
};
